import React from "react";
import { Routes, Route } from "react-router-dom";

// Layout & Pages
import MainLayout from "../layout/MainLayout";
import Home from "../pages/Home";
import Products from "../pages/Products";
import CartPage from "../pages/CartPage";
import About from "../pages/About";
import Settings from "../pages/settings/Settings";
import RegisterPage from "../components/RegisterPage";
import ProductDetails from "../pages/ProductDetails";
import ProductPage from "../pages/ProductPage";
import Dashboard from "../pages/Dashboard";
import ProfilePage from "../pages/Profile/ProfilePage";
import Wallet from "../pages/wallet/Wallet";
import Shipping from "../pages/shipping/Shipping";
import Suggection from "../pages/suggestion/Suggection";

// Components & Features
import LoginPage from "../pages/LoginPage";
import ServicesDirectory from "../components/ProfileDrop/ServicesDirectory";
import RecentActivity from "../components/ProfileDrop/RecentActivity";
import Chart from "../pages/messagea/Chart";

// Protected Routes
import ProtectedRoute from "./ProtectedRoute";

// Seller Pages
import SellerVerification from "../sellers/sellerVerification/SellerVerification";
import SellerDashboard from "../sellers/SellerDashboard";
import SellerHome from "../sellers/page/SellerHome";
import SellerProducts from "../sellers/page/SellerProducts";
import SellerOrders from "../sellers/page/SellerOrders";
import SellerReports from "../sellers/page/SellerReports";
import AddProducts from "../sellers/page/addProducts/AddProducts";
import Inventory from "../sellers/page/addProducts/Inventory";
import Category from "../sellers/page/addProducts/Category";
import BulkUpload from "../sellers/page/addProducts/BulkUpload";
import NewOrder from "../sellers/page/orders/NewOrder";
import ProcessingOrder from "../sellers/page/orders/ProcessingOrder";
import DeleveredOrder from "../sellers/page/orders/DeleveredOrder";
import Return from "../sellers/page/orders/Return";
import OrderDashboard from "../sellers/page/orders/OrderDashboard";
import Earning from "../sellers/page/transaction/Earning";
import PayoutRequest from "../sellers/page/transaction/PayoutRequest";
import Invoice from "../sellers/page/transaction/Invoice";
import CustomersQuery from "../sellers/page/messages/CustomersQuery";
import SupportTickets from "../sellers/page/messages/SupportTickets";
import ProfileSetting from "../sellers/page/account/ProfileSetting";
import Logout from "../sellers/page/account/Logout";

// Admin Pages
import AdminLogin from "../admin/AdminLogin";
import AdminDashboard from "../admin/AdminDashboard";
import User from "../admin/users/User";

// Splash Screen (standalone)
import SplashScreen from "../pages/SplashScreen";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Splash Screen - Full screen, no layout */}
      <Route path="/splash" element={<SplashScreen />} />

      {/* Main Layout - Contains navbar, footer, etc. */}
      <Route path="/" element={<MainLayout />}>
        {/* Public Routes */}
        <Route index element={<Home />} />
        <Route path="products" element={<Products />} />
        <Route path="cart" element={<CartPage />} />
        <Route path="about" element={<About />} />
        <Route path="settings" element={<Settings />} />
        <Route path="register" element={<RegisterPage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="/__message" element={<Chart />} />
        <Route path="/__settings_" element={<Settings />} />

        {/* Product Routes */}
        <Route path="products_parts_materials_categories/:id" element={<ProductDetails />} />
        <Route path="product-page/:id" element={<ProductPage />} />

        {/* Protected Routes - Require Authentication */}
        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/__profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/your_wallet"
          element={
            <ProtectedRoute>
              <Wallet />
            </ProtectedRoute>
          }
        />
        <Route
          path="/shipwithue"
          element={
            <ProtectedRoute>
              <Shipping />
            </ProtectedRoute>
          }
        />
        <Route
          path="/suggestion"
          element={
            <ProtectedRoute>
              <Suggection />
            </ProtectedRoute>
          }
        />

        {/* Feature Routes */}
        <Route
          path="/_products_services_directories"
          element={<ServicesDirectory />}
        />
        <Route
          path="/_your-recent-activity74924679248598243920000000000000000000000000000000000"
          element={<RecentActivity />}
        />

        {/* Seller Verification */}
        <Route
          path="/____seller_verification__"
          element={<SellerVerification />}
        />
      </Route>

      {/* Seller Dashboard - Nested Routes */}
      <Route path="____seller_dashboard" element={<SellerDashboard />}>
        <Route index element={<SellerHome />} />

        {/* Products */}
        <Route path="products" element={<SellerProducts />} />
        <Route path="addProducts" element={<AddProducts />} />
        <Route path="manage_inventory" element={<Inventory />} />
        <Route path="categories" element={<Category />} />
        <Route path="bulk-upload" element={<BulkUpload />} />

        {/* Orders */}
        <Route path="orders" element={<SellerOrders />} />
        <Route path="orderdashboard" element={<OrderDashboard />} />
        <Route path="neworders" element={<NewOrder />} />
        <Route path="processingorder" element={<ProcessingOrder />} />
        <Route path="deleveredOrders" element={<DeleveredOrder />} />
        <Route path="returnOrders" element={<Return />} />

        {/* Transactions */}
        <Route path="earning" element={<Earning />} />
        <Route path="payoutrequest" element={<PayoutRequest />} />
        <Route path="invoice" element={<Invoice />} />

        {/* Messages */}
        <Route path="customersQueries" element={<CustomersQuery />} />
        <Route path="supportQuery" element={<SupportTickets />} />

        {/* Account */}
        <Route path="reports" element={<SellerReports />} />
        <Route path="profileSettings" element={<ProfileSetting />} />
        <Route path="sellerlogout" element={<Logout />} />
      </Route>

      {/* Admin Routes */}
      <Route path="admin_login" element={<AdminLogin />} />
      <Route path="admin_dashboard" element={<AdminDashboard />} />
      <Route path="user" element={<User />} />

      {/* 404 - Catch all route */}
      <Route
        path="*"
        element={
          <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-center">
              <h1 className="text-6xl font-bold text-gray-300">404</h1>
              <p className="text-xl text-gray-600 mt-4">Page not found</p>
              <a
                href="/"
                className="inline-block mt-6 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
              >
                Go Home
              </a>
            </div>
          </div>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
